var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1628_9209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75 10.75H10.75M10.4597 2.36858L9.63142 1.54027C9.24439 1.15324 8.61689 1.15324 8.22986 1.54027L1.54027 8.22986C1.35441 8.41572 1.25 8.6678 1.25 8.93064V10.75H3.06936C3.3322 10.75 3.58428 10.6456 3.77014 10.4597L10.4597 3.77014C10.8468 3.38311 10.8468 2.75561 10.4597 2.36858Z",
    stroke: "#FF7926",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1628_9209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.5ff51f73f57aaa628b1f3696d78aa2f1.svg";
export { ForwardRef as ReactComponent };